export const METRIC_SYSTEM = 'METRIC';
export const IMPERIAL_SYSTEM = 'IMPERIAL';
export type MeasurementSystem = typeof IMPERIAL_SYSTEM | typeof METRIC_SYSTEM;
